(function () {
  'use strict';

  function initProductInfoTabs(container) {
    var drawer    = container.querySelector('.pit-drawer');
    var tabs      = container.querySelectorAll('.pit-tab');
    var panes     = container.querySelectorAll('.pit-pane');
    var closeBtn  = container.querySelector('.pit-close');
    var rowBtns   = container.querySelectorAll('.pit-row-btn');
    var lastFocus = null;

    if (!drawer) return;

    // activate a tab by index
    function activateTab(index) {
      tabs.forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
      panes.forEach(function (p) { p.classList.remove('active'); });
      if (tabs[index]) { tabs[index].classList.add('active'); tabs[index].setAttribute('aria-selected', 'true'); }
      if (panes[index]) { panes[index].classList.add('active'); }
    }

    // default: first tab
    activateTab(0);

    // tab clicks
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activateTab(i); });
    });

    // open drawer to specific tab
    function openDrawer(tabIndex) {
      activateTab(tabIndex);
      lastFocus = document.activeElement;
      drawer.showModal();
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    // close drawer
    function closeDrawer() {
      drawer.classList.add('is-closing');
      drawer.addEventListener('animationend', function handler() {
        drawer.classList.remove('is-closing');
        drawer.close();
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
        drawer.removeEventListener('animationend', handler);
      }, { once: true });
    }

    // row buttons open specific tab
    rowBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tabIndex = parseInt(btn.getAttribute('data-tab-index'), 10) || 0;
        openDrawer(tabIndex);
      });
    });

    // close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    // ESC key
    drawer.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeDrawer();
    });

    // backdrop click (click outside drawer content)
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pit-wrapper').forEach(initProductInfoTabs);
  });
})();
